import React from 'react';
import { CheckCircle2, Clock } from 'lucide-react';
interface PaymentRow {
  date: string;
  amount: number;
  status: 'Paid' | 'Pending';
}
const RECENT: PaymentRow[] = [{
  date: 'May 1, 2026',
  amount: 75.0,
  status: 'Paid'
}, {
  date: 'Apr 1, 2026',
  amount: 75.0,
  status: 'Paid'
}, {
  date: 'Mar 1, 2026',
  amount: 75.0,
  status: 'Pending'
}];
function formatCurrency(n: number) {
  return n.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  });
}
export function RecentPayments() {
  return <section data-id="element-476">
      <h2 className="text-lg font-bold text-brand-navy mb-4" data-id="element-477">
        Recent payments
      </h2>
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-478">
        {RECENT.map((row, i) => <div key={i} className={`flex items-center justify-between gap-4 px-5 py-4 ${i < RECENT.length - 1 ? 'border-b border-gray-100' : ''}`} data-id="element-479">
            <div className="flex items-center gap-3 min-w-0" data-id="element-480">
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${row.status === 'Paid' ? 'bg-green-100' : 'bg-amber-100'}`} data-id="element-481">
                {row.status === 'Paid' ? <CheckCircle2 size={18} className="text-green-600" data-id="element-482" /> : <Clock size={18} className="text-amber-600" data-id="element-483" />}
              </div>
              <div className="min-w-0" data-id="element-484">
                <p className="font-semibold text-brand-dark truncate" data-id="element-485">
                  {formatCurrency(row.amount)}
                </p>
                <p className="text-sm text-brand-muted truncate" data-id="element-486">{row.date}</p>
              </div>
            </div>
            <span className={`text-xs font-semibold px-2.5 py-1 rounded-full uppercase tracking-wider shrink-0 ${row.status === 'Paid' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-487">
              {row.status}
            </span>
          </div>)}
      </div>
    </section>;
}